"use strict";

exports.__esModule = true;
exports.determineLocale = determineLocale;
var _browserLocale = _interopRequireDefault(require("browser-locale"));
var _constants = require("./constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function determineLocale() {
  var selected = localStorage.getItem(_constants.STORAGE_LOCALE_KEY);
  if (selected != null) {
    if (_constants.SUPPORTED_LOCALES[selected]) {
      return _constants.SUPPORTED_LOCALES[selected];
    }
    console.warn("Invalid locale specified. Falling back to default.");
  } else {
    var locale = (0, _browserLocale["default"])().toLowerCase();
    if (_constants.SUPPORTED_LOCALES[locale]) {
      return locale;
    }
    var language = locale.split("-")[0];
    if (_constants.SUPPORTED_LANGUAGES[language]) {
      return _constants.SUPPORTED_LANGUAGES[language];
    }
  }
  return _constants.SUPPORTED_LOCALES["en-us"];
}